import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useWorkspace } from '../context/WorkspaceContext';
import { roleHomePath } from './roleHome';

export const RoleBasedRedirect: React.FC = () => {
  const { user } = useAuth();
  return <Navigate to={roleHomePath(user?.role)} replace />;
};

export const WyscoutRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const { hasWyscout } = useWorkspace();
  if (!hasWyscout) return <Navigate to={roleHomePath(user?.role)} replace />;
  return <>{children}</>;
};
